import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DuvidasSugestoesPage } from './duvidas-sugestoes';
import { DuvidasSugestoesPageProvider } from './duvidas-sugestoes.provider';
import { ListasProvider } from '../../providers/listas/listas';
import { MediaProvider } from '../../providers/media/media';
import { Camera } from '@ionic-native/camera';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { UserProvider } from '../../providers/user/user';

@NgModule({
  declarations: [
    DuvidasSugestoesPage,
  ],
  imports: [
    IonicPageModule.forChild(DuvidasSugestoesPage),
    BrMaskerModule
  ],
  providers: [
    DuvidasSugestoesPageProvider,
    ListasProvider,
    Camera,
    MediaProvider,
    UserProvider
  ]
})
export class DuvidasSugestoesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/duvidas-sugestoes/duvidas-sugestoes.module.ts